import React from 'react';
import styles from './Hero.module.css';
const Hero = ({ title, subtitle, ctaText, ctaLink }) => {
    return (React.createElement("section", { className: styles.hero },
        React.createElement("div", { className: styles.heroContent },
            React.createElement("h1", null, title),
            subtitle && React.createElement("p", { className: styles.heroSubtitle }, subtitle),
            ctaText && ctaLink && (React.createElement("a", { href: ctaLink, className: styles.ctaButton }, ctaText)))));
};
export default Hero;
